export const getTemplates = () => dispatch =>
  dispatch({
    type: 'GET_TEMPLATES',
    payload: {
      request: {
        url: '/api/info/templates'
      }
    }
  })
